import { fieldsetAnatomy } from '@chakra-ui/react/anatomy';
import { defineSlotRecipe } from '@chakra-ui/react/styled-system';

const fieldsetSlotRecipe = defineSlotRecipe({
  className: 'fieldset',
  slots: fieldsetAnatomy.keys(),
  base: {
    errorText: {
      display: 'block',
      marginBlockStart: '12',
      textStyle: 'comp/input/helperText',
      color: 'input/text/error',
    },
    legend: {
      textStyle: 'body/md/semibold',
      color: 'text/primary',
    },
    helperText: {
      display: 'block',
      marginBlockStart: '4',
      textStyle: 'comp/input/helperText',
      color: 'text/helper',
    },
  },
});

export default fieldsetSlotRecipe;
